export default {
  zh: {
    backToEditOpportinity: '返回编辑机会',
    searchAccount: '查找客户',
    opportunityName: '机会名称',
    accountName: '查找客户',
    search: '搜索',
    attachAccount: '关联客户',
    cancel: '取消',
  },
  en: {
    backToEditOpportinity: 'Back to Edit Opportunity',
    searchAccount: 'Search Account',
    opportunityName: 'Opportunity Name',
    accountName: 'Search Account By',
    search: 'Search',
    attachAccount: 'Attach Account',
    cancel: 'Cancel',
  }
};



// WEBPACK FOOTER //
// ./src/views/AttachAccount/i18n.js